<template>
  <div v-if="ticket.device">
         <stepheader :step="step" :ticket="ticket"/>
        <div id="wizard2-p-0" role="tabpanel" aria-labelledby="wizard2-h-0" class="body current" aria-hidden="false" style="">
          <div class="row">
            <div class="col-12">
             I dati in nostro possesso del device con IMEI/Seriale <strong>{{ticket.device.identificativoDevice}}</strong> sono i seguenti: <br/>
             modello {{ticket.device.brand.brand}} {{ticket.device.modello.modello}} 
             <span v-if="ticket.device.memoria">
memoria {{ticket.device.memoria.memoria}}

             </span>.<br/>
             Confermi la correttezza del device in tuo possesso ?
            </div>
          
          </div>
     
          <buttons :buttons=step.buttons v-on:action="fireaction"></buttons>
											
 
  </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "infodevice",

  props: {
    step: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  ticket: {
      type: Object,
      required: false,
    },
    code: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
     
    };
  },
  computed: {
   
  },
  components: {
   
  },
  mounted() {
    console.log(`infodevice - = ${this.ticket.device}`);
    if(!this.ticket.device){
      this.$emit("goto","devices")
    }
  },
  methods: {
    fireaction:function(action,nextstep){
      console.log(`infodevice - action = ${action}`);
      switch(action){
        default:
           this.$emit("goto",nextstep)
          break;

      }

    },
   loaddata: function () {
    
    },

    authenticate:function(nextstep){

    }
  },
};
</script>